import { deleteApi, getApi, patchApi, postApi, putApi } from "../apiCall";

let baseUrl = `${process.env.REACT_APP_API_URL}/payments`;

export const createProduct = (payload) => {
  let url = `${baseUrl}/products`;
  return postApi(url, payload);
};

export const updateProduct = (payload) => {
  let url = `${baseUrl}/products`;
  return putApi(url, payload);
};

export const getProductById = (id) => {
  let url = `${baseUrl}/products/${id}`;
  return getApi(url);
};

export const deleteProduct = (id) => {
  let url = `${baseUrl}/products/${id}`;
  return deleteApi(url);
};

export const getAllProducts = () => {
  let url = `${baseUrl}/products/`;
  return getApi(url);
};

export const createPaymentConfiguration = (payload) => {
  let url = `${baseUrl}/payment-configurations`;
  return postApi(url, payload);
};

export const updatePaymentConfiguration = (payload) => {
  let url = `${baseUrl}/payment-configurations`;
  return putApi(url, payload);
};

export const getPaymentConfigurationById = (id) => {
  let url = `${baseUrl}/payment-configurations/${id}`;
  return getApi(url);
};

export const deletePaymentConfiguration = (id) => {
  let url = `${baseUrl}/payment-configurations/${id}`;
  return deleteApi(url);
};

export const getAllPaymentConfigurations = () => {
  let url = `${baseUrl}/payment-configurations/`;
  return getApi(url);
};

export const getConfigsByProductId = (productId) => {
  let url = `${baseUrl}/products/${productId}/payment-configurations`;
  return getApi(url);
};

export const createProductConfigMappings = (productId, payload) => {
  let url = `${baseUrl}/products/${productId}/payment-configurations`;
  return postApi(url, payload);
};

export const deleteAllConfigsByProductId = (productId) => {
  let url = `${baseUrl}/products/${productId}/payment-configurations`;
  return deleteApi(url);
};

export const deleteSingleConfigMapping = (productId, payload) => {
  let url = `${baseUrl}/products/${productId}/payment-configurations/single`;
  return deleteApi(url, payload);
};

export const createPaymentConfigRule = (payload) => {
  let url = `${baseUrl}/payment-config-rules`;
  return postApi(url, payload);
};

export const updatePaymentConfigRule = (payload) => {
  let url = `${baseUrl}/payment-config-rules`;
  return putApi(url, payload);
};

export const deactivatePaymentConfigRule = (id) => {
  let url = `${baseUrl}/payment-config-rules/${id}/deactivate`;
  return patchApi(url);
};

export const getPaymentConfigRulesByListingType = (listingType) => {
  let url = `${baseUrl}/payment-config-rules/by-listing-type/${listingType}`;
  return getApi(url);
};

export const getAllPaymentConfigRules = () => {
  let url = `${baseUrl}/payment-config-rules/`;
  return getApi(url);
};

export const deletePaymentConfigRule = (id) => {
  let url = `${baseUrl}/payment-config-rules/${id}`;
  return deleteApi(url);
};

export const getConsumersByCompId = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/${id}/getCompanyConsumers`;
  return getApi(url);
};

export const getGeneratorsByCompId = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/super-admin/${id}/getCompanyGenerators`;
  return getApi(url);
};

export const userPaymentConfigurations = ({ role, entityId, companyId }) => {
  let url = `${process.env.REACT_APP_API_URL}/payments/products/${role}/payment-configurations/by-entity?entityId=${entityId}`;
  return getApi(url);
};
